// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/productivity-templates",
  ListShort: "/pyr/productivity-templates/short",
  Me: "/pyr/productivity-templates/me",
  Detail: "/pyr/productivity-templates",
  MeDetail: "/pyr/productivity-templates/me",
  Create: "/pyr/productivity-templates",
  Update: "/pyr/productivity-templates",
  DetailField: "/pyr/productivity-templates/{id}/fields",
  DetailFieldMe: "/pyr/productivity-templates/me/{id}/fields",

  CreateField: "/pyr/productivity-templates/{id}/fields",
  CreateGroupField: "/pyr/productivity-templates/{id}/group-fields",
  UpdateField: "/pyr/productivity-templates/{id}/fields/{fieldId}",
  UpdateFieldBulk: "/pyr/productivity-templates/{id}/fields",
  GroupUpdateField:
    "/pyr/productivity-templates/{id}/group-fields/{groupFieldId}",
  GroupUpdateFieldBulk: "/pyr/productivity-templates/{id}/group-fields",
  DeleteField: "pyr/productivity-templates/{id}/fields/{fieldId}",
  DeleteGroupField:
    "pyr/productivity-templates/{id}/group-fields/{groupFieldId}",

  PrintTemplateList:
    "/pyr/productivity-templates/productivity-template-print-samples",
  PrintTemplateCreate:
    "/pyr/productivity-templates/productivity-template-print-samples",
  PrintTemplateUpdate:
    "/pyr/productivity-templates/productivity-template-print-samples/{id}",
  PrintTemplateDetail:
    "/pyr/productivity-templates/productivity-template-print-samples/{id}",
  PrintTemplateDelete:
    "/pyr/productivity-templates/productivity-template-print-samples/{id}",
};
